/**
 * WordPress dependencies.
 */

/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { attributes, className } = props;
	const { location, language, zoom, height } = attributes;

	const wrapperClasses = classnames(
		className,
		'gutenify-block-map-wrapper'
	);

	return (
		<div className={ wrapperClasses }>
			<iframe title="Google Map" frameBorder="0" src={ `https://www.google.com/maps?q=${ location }&output=embed&hl=${ language }&z=${ zoom }` } style={ `width:100%;min-height:${ height }px` }></iframe>
		</div>

	);
}

